<template>
  <div
    class="modal"
    id="cat-list-dialog"
    :style="myModalStyle"
  >
    <div
      class="modal__header"
      :style="myHeaderStyle"
    >
      <v-layout
        row
        align-center
      >
        <v-flex xs2>
          <v-btn
            icon
            :color="theme.dialog_header_title_color"
            flat
            @click="closeDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          xs10
          mr-1
          text-xs-right
          class="nowrap-text"
        >
          <span
            :style="myTitleStyle"
            class="name"
          >{{ $t('add_item') }}</span>
        </v-flex>
      </v-layout>
    </div>
    <div
      class="modal__content"
      id="cat-list-dialog-content"
      :style="myContentStyle"
      v-body-scroll-lock="catListDialog"
    >
      <div v-if="catList.length > 0">
        <v-expansion-panel
          style="box-shadow: none;"
          v-model="panel"
        >
          <v-expansion-panel-content
            v-for="(cat, index) in catList"
            :key="index"
            :style="myMenuStyle"
          >
            <strong
              slot="header"
              :style="myTitleStyle"
            >{{ catName(cat) }}</strong>
            <v-icon slot="actions">{{ icon(index) }}</v-icon>
            <div v-if="items['c' + cat.category_id]">
              <v-layout
                row
                wrap
              >
                <v-flex
                  d-flex
                  xs12
                  sm12
                  md6
                  lg6
                  xl4
                  v-for="i in items['c' + cat.category_id]"
                  :key="i.plu_id"
                >
                  <simple-cat-item
                    v-if="itemAvailable(i)"
                    :item="i"
                    :multiplePlus="multiplePlus(i)"
                  />
                </v-flex>
              </v-layout>
            </div>
            <div v-else-if="!loading">
              <no-cat-item from-custom-sets />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <menu-item-dialog v-if="menuItemDialog" from-custom-sets @add-item="addItem" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import SimpleCatItem from '~/components/SimpleCatItem'
import NoCatItem from '~/components/NoCatItem'
import MenuItemDialog from '~/components/MenuItemDialog'

export default {
  name: 'cat-list-dialog-component',
  components: {
    'simple-cat-item': SimpleCatItem,
    'no-cat-item': NoCatItem,
    'menu-item-dialog': MenuItemDialog
  },
  props: {
    cat: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      panel: [],
      loading: true
    }
  },
  computed: {
    ...mapGetters('config', [
      'config', 'theme', 'language', 'iOS', 'inIframe'
    ]),
    ...mapGetters('menu', [
      'catList', 'catListDialog', 'items', 'menuItemDialog'
    ]),
    myModalStyle () {
      return {
        backgroundColor: this.theme.login_bg_color
      }
    },
    myHeaderStyle () {
      return {
        backgroundColor: this.theme.dialog_header_bg_color
      }
    },
    myTitleStyle () {
      return {
        color: this.theme.dialog_header_title_color
      }
    },
    myContentStyle () {
      return {
        position: 'absolute',
        bottom: '64px',
        top: '48px',
        backgroundColor: this.theme.login_bg_color
      }
    },
    myMenuStyle () {
      return {
        backgroundColor: this.theme.login_bg_color
      }
    }
  },
  watch: {
    async panel (val) {
      if (val !== null && this.catList[val]) {
        this.loading = true
        const key = 'c' + this.catList[val].category_id
        if (!this.items[key]) {
          await this.$store.dispatch('fetchCatItems', this.catList[val].category_id)
        }
      }
      this.loading = false
    }
  },
  methods: {
    icon (index) {
      let icon = '$vuetify.icons.expand'
      if (index === this.panel && this.loading) {
        icon = 'fas fa-circle-notch fa-spin'
      }
      return icon
    },
    catName (cat) {
      if (this.language !== 'en-SG') {
        return cat.alternate_name || cat.name
      }
      return cat.name
    },
    itemAvailable (item) {
      return parseInt(item.is_enabled) === 1 && (item.inventory_left === 'NA'
        || parseInt(item.inventory_left) > 0)
    },
    multiplePlus (item) {
      return this.items['c' + item.category_id].find(c => parseInt(c.item_id) === parseInt(item.item_id) && parseInt(c.plu_id) !== parseInt(item.plu_id)) ? true : false
    },
    closeDialog () {
      // Re-enable body scroll
      // enableBodyScroll(document.getElementById('menu-item-dialog-content'))
      this.$store.dispatch('menu/hideCatListDialog')
    },
    addItem (item) {
      const options = item.options ? item.options : []
      const toppings = item.toppings ? item.toppings : []
      const quantity = item.quantity ? item.quantity : 1
      this.$emit('add-item', {
        voucher_id: null,
        member_voucher_id: null,
        item_id: item.item.item_id,
        category_id: item.item.category_id,
        category_name:item.item.category_name,
        category_alternate_name:item.item.category_alternate_name,
        name: item.item.name,
        alternativeName: item.item.alternate_name,
        portion_size_name: item.item.portion_size_name,
        priceText: item.item.price_text,
        plu_id: item.item.plu_id,
        price: item.item.price,
        price_override: item.item.price_override || null,
        quantity: quantity,
        final_price: item.final_price || item.item.price,
        tax: item.item.tax,
        service_charge: item.item.service_charge,
        remarks: item.special_req || null,
        time_required: item.item.time_required || 0,
        tray_count: item.item.tray_count,
        modifiers: options.concat(toppings),
        options: options,
        toppings: toppings,
        is_set_meal: item.item.is_set_meal,
        set_course_items: item.set_course_items || [],
        non_discount: item.item.non_discount,
        photo_url: item.item.photo_url,
        courses: item.item.courses,
        option_groups: item.item.option_groups,
        max_quantity: item.item.max_quantity || 10,
        min_quantity: item.item.min_quantity || 1
      })
    }
  }
}
</script>

<style scoped>
.modal {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 200;
}
.modal__header {
  height: 48px;
}
.modal__content {
  width: 100%;
  overflow-y: auto;
  padding: 10px 24px;
}
.name {
  padding-right: 16px;
}
.nowrap-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/CatListDialog.vue